<!-- <app-inline-generic-error *ngIf="hasError"></app-inline-generic-error> -->
<ion-list
  class="ion-no-padding ion-padding-top ion-list-transparent-bg-color airport-selector"
>
  <ion-item
    (click)="presentModal()"
    lines="none"
    class="ion-item-transparent-bg-color grey-border border-r8 marh7"
    *ngIf="noFlights || flights?.length > 0 || !airport"
  >
    <ion-thumbnail slot="start">
      <custom-icon iconName="AIRPORT" [width]="56" [height]="56"></custom-icon>
    </ion-thumbnail>
    <ion-label *ngIf="airport">
      <h6 class="fs-3 font500 paragraph-primary-text-color">
        {{ airport }} - {{ airportInfo.name || airportInfo.airportName }}
      </h6>
      <p class="fs-3 font400 paragraph-secondary-text-color">
        {{ airportInfo?.city }}, {{ airportInfo?.country }}
      </p>
    </ion-label>
    <ion-label *ngIf="!airport">
      <h3 class="fs-5 font500 paragraph-primary-text-color">
        {{ "airport_list.header" | translate }}
      </h3>
    </ion-label>
    <ion-icon
      slot="end"
      class="primary-icon-color"
      name="create-outline"
    ></ion-icon>
  </ion-item>
</ion-list>

<div *ngIf="flights?.length > 0; else noAirport">
  <ion-grid class="ion-no-padding ion-margin-top departure-container">
    <div>
      <ion-row class="ion-text-center ion-no-padding">
        <ion-col size="3">
          <ion-label class="fs-2 font500 black-text-color">{{
            "trips.search_flights.flight_departure.flight_title" | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="3">
          <ion-label class="fs-2 font500 black-text-color">{{
            "trips.search_flights.flight_departure.flight_to" | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="3">
          <ion-label class="fs-2 font500 black-text-color">{{
            "trips.search_flights.flight_departure.flight_departs" | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="3">
          <ion-label class="fs-2 font500 black-text-color">{{
            "trips.search_flights.flight_departure.flight_status" | translate
          }}</ion-label>
        </ion-col>
      </ion-row>
    </div>
    <div class="seperator"></div>
  </ion-grid>
  <ion-grid class="flightcard-list ion-no-padding">
    <div *ngFor="let item of flights">
      <flight-list-card [flight]="item"></flight-list-card>
    </div>
    <ion-infinite-scroll (ionInfinite)="getNextPage($event)">
      <ion-infinite-scroll-content loadingSpinner="crescent">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-grid>
</div>

<ng-template #noAirport>
  <div *ngIf="!airport; else noFlighhts" class="add-flight-container">
    <no-data message="No Airport Selected" imcomingImage="LOCATION" />
  </div>
</ng-template>

<ng-template #noFlighhts>
  <div *ngIf="noFlights" class="add-flight-container">
    <no-data
      message="no_data.oops_no_flights_found"
      imcomingImage="NO_FLIGHT_AVAILABLE"
    />
  </div>
</ng-template>
